import { Navigate } from 'react-router-dom'
import { URLS } from 'utils/constants'
import { isAuthenticated, getUserRoles } from 'utils/authService'
import { NotFound } from 'components/ideal-core-ui'
import { hasModule } from 'utils/helpers'

const PrivateRoute = ({ component: RouteComponent, allow, hasModuleOn, restricted, ...props }) => {
  const isModuleOn = hasModuleOn ? hasModule(hasModuleOn) : true
  const roles = allow && allow.split(' ')
  const userRoles = getUserRoles()
  // if no role restriction is present on the route then everything is allowed
  const isAllowed = roles && userRoles ? userRoles.some(r => roles.includes(r)) : true

  return isAuthenticated() ? (
    isAllowed && isModuleOn && !restricted ? (
      <RouteComponent {...props} />
    ) : (
      <NotFound />
    )
  ) : (
    <Navigate to={URLS.LOGIN} />
  )
}

export default PrivateRoute
